// extracted by mini-css-extract-plugin
module.exports = {"accordion":"BundleProductAccordion_accordion__UO7VL","accordionTitle":"BundleProductAccordion_accordionTitle__zUkaQ"};